import "./OurProducts4.module.css";
import Header from "@/reusable_sections/Header";
import ProductShowcase from "./sections/ProductShowcase";
import ProductCategoryFilters from "./sections/ProductCategoryFilters";
import Footer from "@/reusable_sections/Footer";
export default function OurProducts4Page() {
  return <div>
      <Header />
      <ProductShowcase />
      <ProductCategoryFilters />
      <Footer />
    </div>;
}